/* unplugin-vue-components disabled */import { render } from "./node.vue?vue&type=template&id=584fafe4&scoped=true"
import script from "./node.vue?vue&type=script&lang=js"
export * from "./node.vue?vue&type=script&lang=js"

import "./node.vue?vue&type=style&index=0&id=584fafe4&lang=stylus&scoped=true"

import exportComponent from "/home/runner/work/buzz-front/buzz-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-584fafe4"],['__file',"src/components/widgets/org-map/node.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "584fafe4"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('584fafe4', __exports__)) {
    api.reload('584fafe4', __exports__)
  }
  
  module.hot.accept("./node.vue?vue&type=template&id=584fafe4&scoped=true", () => {
    api.rerender('584fafe4', render)
  })

}


export default __exports__